const rankingItems = [
  { rank: 1, title: '顶流男星深夜私会女网红？监控画面曝光', heat: '980万', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '知名导演被曝剧组霸凌，多位演员实名举报', heat: '860万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '某综艺节目黑幕录音外泄，制作人连夜辞职', heat: '750万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 4, title: '娱乐圈豪门婚变再起波澜，律师团队已介入', heat: '680万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 5, title: '网红直播带货翻车现场，品牌方集体解约', heat: '590万', tag: '', tagColor: '' },
  { rank: 6, title: '年度音乐盛典内定名单泄露，主办方紧急公关', heat: '520万', tag: '新', tagColor: 'bg-secondary-500' },
];

function RankBadge({ rank }: { rank: number }) {
  if (rank === 1)
    return (
      <span className="w-7 h-7 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center text-xs font-bold">
        1
      </span>
    );
  if (rank === 2)
    return (
      <span className="w-7 h-7 rounded-lg bg-accent-500 text-background-50 flex items-center justify-center text-xs font-bold">
        2
      </span>
    );
  if (rank === 3)
    return (
      <span className="w-7 h-7 rounded-lg bg-secondary-500 text-background-50 flex items-center justify-center text-xs font-bold">
        3
      </span>
    );
  return (
    <span className="w-7 h-7 rounded-lg bg-background-200 text-foreground-500 flex items-center justify-center text-xs font-bold">
      {rank}
    </span>
  );
}

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">热度榜单</h2>
          <p className="text-foreground-500 text-sm">实时更新，今日最受关注的爆料内容</p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
          {rankingItems.map((item, i) => (
            <a
              key={item.rank}
              href="#ranking"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/50' : ''
              }`}
            >
              <RankBadge rank={item.rank} />
              <div className="flex-1 min-w-0">
                <p className="text-sm text-foreground-800 truncate">{item.title}</p>
              </div>
              {item.tag && (
                <span
                  className={`px-2 py-0.5 rounded text-[10px] font-medium text-background-50 ${item.tagColor} whitespace-nowrap`}
                >
                  {item.tag}
                </span>
              )}
              <span className="text-xs text-foreground-400 whitespace-nowrap flex items-center gap-1">
                <i className="ri-fire-line text-accent-500"></i>
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}